import React, { useEffect, useRef, useState } from 'react'
import PageLoader from '../../commoncomponents/PageLoader';
import { DefaultCard } from '../../../assets/styled-components/card';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAuthToken, getcompanyId, getFacilityId, getuserId } from '../../../utility/tokenUtility';
import PageTitle from '../../commoncomponents/PageTitle';
import CustomSelectInput from "../../commoncomponents/CustomSelectInput";
import { ifacSecurityURL } from '../../../utility/apiURLS';
import axios from 'axios';
import ViewAssetMedicalRiskManagment from './ViewAssetMedicalRiskManagment';
import AssetMedicalRiskChecklist from './AssetMedicalRiskChecklist';

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1250px",
    height: "100%",
    maxHeight: "calc(100% - 64px)",
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
    overflowY: "auto",
    overflowX: "hidden",
};

const AssetMedicalRiskManagment = () => {
    const [year, setYear] = useState(null);
    const [hospital, setHospital] = useState("");
    const [hospitalOptions, setHospitalOptions] = useState([]);
    const childRef = useRef(null);
    const childRefCheckList = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const [checkListModal, setCheckListModal] = useState(false);
    const [optionsDisable, setOptionsDisable] = useState(false);
    const [getListCheckList, setGetListCheckList] = useState("");
    const [editform, setEditForm] = useState(true);
    const Rolename = localStorage.getItem("roleName");

    const leveloptions = [
        { label: "Hospital", value: "Hospital", id: 1 },
        { label: "HQ", value: "HQ", id: 2 },
    ];

    const summaryoptions = [
        { label: "Medical Device Risk ", value: "Medical Device Risk ", id: 1 },
        { label: "Annual- Medical Device Risk Condition Evaluation", value: "Annual- Medical Device Risk Condition Evaluation", id: 2 },
    ];


    const quarterOptions = [
        { label: "All", value: "" },
        { label: "Q1 (Jan - Mar)", value: "Q1" },
        { label: "Q2 (Apr - Jun)", value: "Q2" },
        { label: "Q3 (Jul - Sep)", value: "Q3" },
        { label: "Q4 (Oct - Dec)", value: "Q4" },
    ];

    // Initialize the state directly using the helper function

    const getCurrentQuarterOption = () => {
        const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 11 = Dec
        if (currentMonth >= 0 && currentMonth <= 2) return quarterOptions[1];
        if (currentMonth >= 3 && currentMonth <= 5) return quarterOptions[2];
        if (currentMonth >= 6 && currentMonth <= 8) return quarterOptions[3];
        return quarterOptions[4];
    };

    const [level, setLevel] = useState(leveloptions[0]);
    const [summary, setSummary] = useState(summaryoptions[0]);
    const [quarter, setQuarter] = useState(getCurrentQuarterOption());
    const [quarterDisable, setQuarterDisable] = useState(false);

    useEffect(() => {
        if (summary?.id === 2) {
            setQuarter(quarterOptions[0]); // Set quarter to "All"
            setQuarterDisable(true);       // Disable the select dropdown
        } else {
            setQuarterDisable(false);
            // Optional: Reset back to current quarter if they switch away from Annual evaluation
            setQuarter(getCurrentQuarterOption());
        }
    }, [summary]);



    const riskStatusOptions = [
        { label: "All", value: "All", id: 0 },
        { label: "High Risk", value: "High Risk", id: 1 },
        { label: "Moderate Risk", value: "Moderate Risk", id: 2 },
    ];
    const [riskStatus, setRiskStatus] = useState(riskStatusOptions[0]);

    const assetconditionOptions = [
        { label: "All", value: "All", id: 0 },
        { label: "Good", value: "Good", id: 1 },
        { label: "Fair", value: "Fair", id: 2 },
        { label: "Poor", value: "Poor", id: 3 },
    ];
    const [assetcondition, setAssetCondition] = useState(assetconditionOptions[0]);

    const currentYear = new Date().getFullYear();
    const token = getAuthToken("id_token");
    const userId = getuserId("userId");
    const companyId = getcompanyId("companyId");
    const facilityId = getFacilityId("facilityId");
    const [loading, setLoading] = useState(false);

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const yearsOptions = Array.from(
        { length: currentYear - 2016 + 1 },
        (_, i) => ({
            label: (2016 + i).toString(),
            value: (2016 + i).toString(),
        })
    );

    useEffect(() => {
        setYear({ label: currentYear.toString(), value: currentYear.toString() });
    }, []);

    const handleQuarterChange = (selectedOption) => {
        setQuarter(selectedOption);
    };

    const handleOptionsChange = (option) => {
        setSummary(option);
        setCheckListModal(false);
    };
    const handleRiskStatusChange = (riskstatus) => {
        setRiskStatus(riskstatus);
    };
    const handleAssetConditionChange = (assetcondition) => {
        setAssetCondition(assetcondition);
    };


    useEffect(() => {
        fetchOptions();
    }, []);

    const fetchOptions = async () => {
        try {
            const response = await axios.get(
                `${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}?size=100`,
                config
            );
            const options = response.data.map((item) => ({
                ...item,
                label: item.facilityName,
                value: item.facilityName,
                id: item.facilityId,
            }));

            setHospitalOptions(options);
            const selectedHospital = options.find((option) => option.id === facilityId);
            setHospital(selectedHospital);
        } catch (error) {
            console.error("Failed to fetch hospital data:", error);
        }
    };

    const handleYearChange = (newValue) => {
        if (newValue && newValue.value !== year.value) {
            setYear(newValue);
        }
    };

    const handleLevelChange = (newValue) => {
        if (newValue) {
            if (newValue?.value === "HQ") {
                setHospital("");
            } else {
                setHospital(hospitalOptions.find((option) => option.id === facilityId));
            }
            setLevel(newValue);
        }
    };

    const handleRefresh = () => {
        setLevel(leveloptions[0]);
        setYear({ label: currentYear.toString(), value: currentYear.toString() });
        setHospital(hospitalOptions.find((option) => option.id === facilityId));
        setSummary(summaryoptions[0]);
        setQuarter(getCurrentQuarterOption());
        setRiskStatus(riskStatusOptions[0]);
        setAssetCondition(assetconditionOptions[0]);
        setOptionsDisable(false);
        setQuarterDisable(false);
        setEditForm(true);

    };

    const handleGetResultClick = () => {
        if (summary.id === 1) {
            setOpenModal(true);
            setOptionsDisable(true);
        } else if (summary.id === 2) {

            setGetListCheckList(prev => !prev); // toggle so child sees change
            setCheckListModal(true);
            setOptionsDisable(true);

        }

    };

    const handleHospitalChange = (newValue) => {
        setHospital(newValue);
    };

    const handleClose = () => {
        setOpenModal(false);
        setEditForm(true);
    };

    // Forward toolbar clicks to child reference handlers
    const handlePrintClick = () => {
        if (childRef.current?.handlePrint) {
            childRef.current.handlePrint();
        }
    };

    const handleEditForm = () => {
        setEditForm(false);
    };

    const handleDownloadClick = () => {
        if (childRef.current?.handleDownloadPDF) {
            childRef.current.handleDownloadPDF();
        }
    };
    const handleSaveRiskAssessment = () => {
        if (childRef.current) {
            childRef.current.handleSave();
            setEditForm(true);
        }
    };

    // Submits the workflow directly to the child's unified download & attach pipeline
    const handleSubmitClick = () => {
        if (childRef.current) {
            childRef.current.handleSubmitToOutlook();
        }
    };

    return (
        <>
            <PageLoader open={loading} />
            <PageTitle title={`Asset Medical Risk Managment Report`} />
            <DefaultCard>
                <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                    MEDICAL DEVICE RISK ASSESSMENT REPORT
                </Typography>
                <br />
                <Grid container spacing={3}>
                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            label={"Level"}
                            options={leveloptions}
                            value={level}
                            onChange={handleLevelChange}
                            disableClearable={true}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            label="Options"
                            name="Options"
                            id="Options"
                            options={summaryoptions}
                            value={summary}
                            onChange={handleOptionsChange}
                            disableClearable={true}
                            disabled={optionsDisable}
                        />
                    </Grid>
                    {level.value === "Hospital" && (
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Hospital"
                                name="Hospital"
                                id="Hospital"
                                options={hospitalOptions}
                                value={hospital}
                                onChange={handleHospitalChange}
                                disableClearable={true}
                            />
                        </Grid>
                    )}

                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            label="Year"
                            name="Year"
                            options={yearsOptions}
                            value={year}
                            onChange={handleYearChange}
                            placeholder={"Select Year"}
                            disableClearable={true}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            label="Quarter"
                            name="Quarter"
                            options={quarterOptions}
                            value={quarter}
                            onChange={handleQuarterChange}
                            disableClearable={true}
                            disabled={quarterDisable}
                        />
                    </Grid>

                    {summary.id === 2 && (
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Risk Status"
                                name="Risk Status"
                                id="Risk Status"
                                options={riskStatusOptions}
                                value={riskStatus}
                                onChange={handleRiskStatusChange}
                                disableClearable={true}
                            />
                        </Grid>
                    )}
                    {summary.id === 2 && (
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Asset Condition"
                                name="Asset Condition"
                                id="Asset Condition"
                                options={assetconditionOptions}
                                value={assetcondition}
                                onChange={handleAssetConditionChange}
                                disableClearable={true}
                            />
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ display: "flex", gap: 2, justifyContent: { xs: "center", md: "end" }, mt: 3 }}>
                    <Button variant="contained" onClick={handleGetResultClick}>
                        Get Result
                    </Button>
                    <Button variant="outlined" onClick={handleRefresh}>
                        Refresh
                    </Button>
                </Box>
            </DefaultCard>

            {(checkListModal && summary.id === 2) && (
                <AssetMedicalRiskChecklist
                    ref={childRefCheckList}
                    data={{ year: year, month: quarter, hospital: hospital, riskStatus: riskStatus, assetcondition: assetcondition, getListCheckList }} />
            )}

            <Modal open={openModal} sx={{ "& .MuiBackdrop-root": { backgroundColor: "transparent" } }}>

                <Box sx={ModalStyle}>
                    <Box sx={{ width: '100%', display: 'flex', gap: 1, justifyContent: { xs: 'center', md: 'flex-end' }, marginBottom: 2, marginTop: 3 }}>
                        <Button variant='contained' color="success" onClick={handleSubmitClick}>
                            Submit
                        </Button>
                        <Button variant='contained' onClick={handlePrintClick}>Print</Button>
                        <Button variant='contained' onClick={handleDownloadClick}>Download</Button>
                        <Button variant='contained' onClick={handleClose}>Close</Button>
                    </Box>

                    {openModal && (
                        <ViewAssetMedicalRiskManagment
                            ref={childRef}
                            data={{ setOpenModal, quarter, year, hospital, editform }}
                        />
                    )}
                    {(Rolename === "CorporateAdmin" || Rolename === "FMSExec" || Rolename === "HospitalFM") &&
                        <Box sx={{ width: '100%', display: 'flex', gap: 1, justifyContent: { xs: 'center', md: 'flex-end' }, marginBottom: 2, marginTop: 3 }}>
                            <Button variant='contained' onClick={handleSaveRiskAssessment} >Save</Button>
                            <Button variant='outlined' onClick={handleEditForm}>Edit</Button>

                        </Box>}

                </Box>
            </Modal>
        </>
    )
}

export default AssetMedicalRiskManagment;